module.exports = __webpack_public_path__ + "static/media/MVI.f41ac1fd.jpg";